<script>
    import { onDestroy, onMount } from "svelte";
    import sounds from "../sounds";
    import { newGame } from "../store";

    export let backgroundImage;

    let count = 3;

    sounds.countdownTick.player.play();

    const intervalRef = setInterval(() => {
        if (count > 0) {
            sounds.countdownTick.player.play();
            count = count - 1;
        }

        if (count == 0) {
            newGame();
        }
    }, 1000);

    onMount(() => {
        let vh = window.innerHeight * 0.01;

        document.documentElement.style.setProperty("--vh", `${vh}px`);

        window.addEventListener("resize", () => {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty("--vh", `${vh}px`);
        });

        document.body.style.overflow = "hidden";
        document.body.style.height = "100vh";
    });

    onDestroy(() => {
        clearInterval(intervalRef);
        document.documentElement.style = "";
        document.body.style.overflow = "";
    });

    let bgImageTemplate = `background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url("${backgroundImage}");`;
</script>

<style>
    .container {
        height: 100vh;
        /* Use vh as a fallback for browsers that do not support Custom Properties */
        height: calc(var(--vh, 1vh) * 100);
        margin: 0 auto;
        max-width: 100%;
        user-select: none;
        background-image: none;
    }
</style>

<div class="container pause-screen" style={bgImageTemplate}>
    {#if count < 3}
        {#if count == 2}
            <svg
                width="212"
                height="212"
                viewBox="0 0 212 212"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M77.04 149H134.4V133.88H99.36L116.28 118.76C129.48 107 134.4 98 134.4 87.44C134.4 69.68 121.8 58.64 105.24 58.64C84.36 58.64 75.48 75.08 76.08 90.92H92.04C91.44 83 95.52 73.76 105.72 73.76C114.6 73.76 118.44 80.48 118.44 87.2C118.44 95.96 112.68 100.76 107.64 105.44L77.04 133.88V149Z"
                    fill="white" />
                <circle
                    cx="106"
                    cy="106"
                    r="105"
                    stroke="white"
                    stroke-width="2" />
            </svg>
        {/if}

        {#if count == 1}
            <svg
                width="212"
                height="212"
                viewBox="0 0 212 212"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M106.84 149H122.8V60.2H104.44L76 96.8L88.6 106.4L106.84 82.52V149Z"
                    fill="white" />
                <circle
                    cx="106"
                    cy="106"
                    r="105"
                    stroke="white"
                    stroke-width="2" />
            </svg>
        {/if}
    {:else}
        <svg
            width="212"
            height="212"
            viewBox="0 0 212 212"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M96.24 81.8C96.12 76.28 100.44 73.76 104.4 73.76C108.96 73.76 111.84 77.48 111.84 82.16C111.84 91.16 103.08 91.4 100.32 91.4H98.04V106.52H100.8C103.92 106.52 118.2 106.52 118.2 121.64C118.2 129.68 112.32 136.04 104.04 136.04C95.04 136.04 90.48 129.32 89.76 122.72H73.8C74.76 138.92 87.12 151.16 103.92 151.16C120.6 151.16 134.16 139.52 134.16 121.76C134.16 110.96 129.48 101.96 120.12 98.12C126.6 93.08 127.8 86.36 127.8 82.28C127.8 67.64 117.12 58.64 104.16 58.64C89.76 58.64 80.16 68.36 80.28 81.8H96.24Z"
                fill="white" />
            <circle cx="106" cy="106" r="105" stroke="white" stroke-width="2" />
        </svg>
    {/if}
</div>
